var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_4092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5714 3.7144L11.1905 0.666783C9.95238 -0.19036 8.23809 -0.19036 7 0.666783L2.42857 3.7144C1.19047 4.57155 0.42857 6.00012 0.42857 7.52393V13.2382C0.42857 15.8096 2.52381 17.9049 5.09524 17.9049H12.8095C15.381 17.9049 17.4762 15.8096 17.4762 13.2382V7.52393C17.5714 6.00012 16.8095 4.57155 15.5714 3.7144ZM11.9524 11.7144C10.9048 12.5715 9.95238 12.8573 9 12.8573C7.66667 12.8573 6.61905 12.1906 6.04762 11.6192C5.7619 11.3334 5.7619 10.762 6.04762 10.4763C6.33333 10.1906 6.90476 10.1906 7.19047 10.4763C7.38095 10.6668 9 12.0954 10.9048 10.4763C11.2857 10.1906 11.7619 10.1906 12.0476 10.5715C12.3333 10.9525 12.2381 11.4287 11.9524 11.7144Z",
    fill: "#CCED46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_4092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.498ec2dfe51a633a75fe9704f1356489.svg";
export { ForwardRef as ReactComponent };